import { namespacedConsts, } from '../../jsCore/utils/object';

export const SOCIAL_BAR_ACTION_TYPES = namespacedConsts({
  REACTIONS: {
    GET_VOTES: true,
    SEND_VOTE: true,
    DISPLAY: true,
    HIDE: true,
    SET_REACTIONS_COMPONENT_STATE: true,
  },
});


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/socialBarActionTypes.js